import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { Ref, ref, computed } from '@vue/composition-api';
import { StateEnum, useStdAdgroupIs, useAdgroupLocation, useStore } from '@tt4b/ttam-hooks';
export function usePangleSupportCityTipsPropsVisible(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData, campaignData } = props;
  const { state } = useStore();
  const areaData = state[StateEnum.areaData].data;
  const areaMap = computed(() => areaData.value?.areaMap ?? {});
  const unsupportedCountriesIds = computed(() => areaData.value?.unsupportedCountryIds ?? []);

  const { isHasPangle, isHasTopbuzz } = useStdAdgroupIs({
    campaignFormData: campaignData,
    adgroupFormData: adgroupData,
  });
  const { hasPangleUnSupportCityLocation } = useAdgroupLocation({
    adgroupFormData: adgroupData,
    areaMap,
    areaList: ref([]),
    accountCountry: ref(''),
    unsupportedCountriesIds,
  });
  const visible = computed(() => (isHasPangle.value || isHasTopbuzz.value) && hasPangleUnSupportCityLocation.value);
  return {
    visible,
  };
}
